var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1658 1.84207C12.8241 1.5004 12.2324 1.73373 12.2324 2.20873V5.11707C12.2324 6.33373 13.2658 7.34207 14.5241 7.34207C15.3158 7.3504 16.4158 7.3504 17.3574 7.3504C17.8324 7.3504 18.0824 6.79207 17.7491 6.45873C16.5491 5.2504 14.3991 3.0754 13.1658 1.84207Z",
    fill: "#007FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.084 8.49102H14.6757C12.7007 8.49102 11.0923 6.88268 11.0923 4.90768V2.49935C11.0923 2.04102 10.7173 1.66602 10.259 1.66602H6.72565C4.15898 1.66602 2.08398 3.33268 2.08398 6.30768V13.691C2.08398 16.666 4.15898 18.3327 6.72565 18.3327H13.2757C15.8423 18.3327 17.9173 16.666 17.9173 13.691V9.32435C17.9173 8.86602 17.5423 8.49102 17.084 8.49102ZM9.58398 14.791H6.25065C5.90898 14.791 5.62565 14.5077 5.62565 14.166C5.62565 13.8243 5.90898 13.541 6.25065 13.541H9.58398C9.92565 13.541 10.209 13.8243 10.209 14.166C10.209 14.5077 9.92565 14.791 9.58398 14.791ZM11.2507 11.4577H6.25065C5.90898 11.4577 5.62565 11.1743 5.62565 10.8327C5.62565 10.491 5.90898 10.2077 6.25065 10.2077H11.2507C11.5923 10.2077 11.8757 10.491 11.8757 10.8327C11.8757 11.1743 11.5923 11.4577 11.2507 11.4577Z",
    fill: "#007FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.be78cf107b5581ac32f1a1716003397c.svg";
export { ForwardRef as ReactComponent };